import { apiClient } from '@devd-client/api';
import { getToken, getAuthId, getOrgId } from '../helpers/authHelpers';

export const verifyResetPasswordToken = (code: string): Promise<any> =>
  apiClient(`/v1/verify-reset-password-token/${code}`, {
    method: 'GET',
  });

export const resetPassword = (params: any): Promise<any> =>
  apiClient(`/v1/reset-password`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

export const getUser = (): Promise<any> =>
  apiClient(`/v2/account/user/${getAuthId()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const getOrdinalSteps = (): Promise<any> =>
  apiClient(`/v2/account/org/${getOrgId()}/setup`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getActiveOrganizations = (
  pageNo = 0,
  pageSize = 20,
  sortBy = 'createdAt',
  search?: string
): Promise<any> =>
  apiClient(
    `/v2/admin/organizations/active?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=${sortBy}${
      search ? `&search=${encodeURIComponent(search)}` : ''
    }`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getSupportLoginDetails = (organizationId: string): Promise<any> =>
  apiClient(`/v2/admin/organizations/${organizationId}/support-login`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getIntegrationDetails = (
  orgId: string,
  integrationType: string,
  integration: string
): Promise<any> =>
  apiClient(
    `/v2/admin/organizations/${orgId}/integration/${integrationType}/${integration}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );

const CHAT_API_BASE = process.env['NX_CHAT_API_HOST'];

export interface OrgTokenUsageResponse {
  orgId: string;
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  message_count: number;
  input_cost_usd: number;
  output_cost_usd: number;
  total_cost_usd: number;
  avg_cost_per_message_usd: number;
  avg_cost_per_1k_tokens_usd: number;
}

export const getOrgTokenUsageBulk = async (
  orgIds: string[]
): Promise<OrgTokenUsageResponse[]> => {
  const response = await fetch(`${CHAT_API_BASE}/chat/token-usage/bulk`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ orgIds }),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch org token usage');
  }

  return response.json();
};
